import React from 'react';
import TextCell from '../TextCell';
import SortHeaderCell from '../SortHeaderCell';
import { Table, Column, Cell } from 'fixed-data-table';
import * as actions from '../../redux/actions';
import DataTableUtil from '../../DataTableUtil';
import Storage from '../../Storage';
import { SortTypes } from '../../Constants';
import BaseLayout from '../pages/BaseLayout';
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import XLSX from 'xlsx';
import FileSaver from 'file-saver';

import Api from '../../Api';

const FILTER_COLUMNS = [
  'srcorgname',
  'srclocname',
  'trgtorgname',
  'trgtlocname',
  'status',
  'startdate',
  'completedate',
  'agent',
];
const DEFAULT_COL_SORT_DIRS = { startdate: SortTypes.DESC };
const DEFAULT_TABLE_WIDTH = 1200;
const DEFAULT_TABLE_HEIGHT = 500;

function getFilterKey(tableTitle = 'Org2OrgCopyPageHistory') {
  return tableTitle + ' : filterText';
}

function getColSortKey(tableTitle = 'Org2OrgCopyPageHistory') {
  return tableTitle + ' : columnSortDirs';
}

class Org2OrgCopyPageHistory extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showdetail: false,
      showErrorModal: false,
      errorMsg: '',
      filterText: Storage.getSessionItem(getFilterKey(props.tableTitle)) || '',
      columnSortDirs:
        Storage.getSessionItem(getColSortKey(props.tableTitle)) || DEFAULT_COL_SORT_DIRS,
      srcorgname: '',
      srclocname: '',
      trgtorgname: '',
      trgtlocname: '',
      rowId: '',
      productCount: 0,
      exportConfirmation: false,
      isDisabledUndo: false,
    };

    this.handleSortChange = this.handleSortChange.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.handleUndoClick = this.handleUndoClick.bind(this);
    this.backToTable = this.backToTable.bind(this);
    this.revertCopy = this.revertCopy.bind(this);
    this.fetchExcelData = this.fetchExcelData.bind(this);
    this.handelexportConfirmation = this.handelexportConfirmation.bind(this);
  }

  componentDidMount() {
    let { dispatch } = this.props;
    dispatch(actions.getOrg2OrgHistoryCopyList());
  }

  handelexportConfirmation() {
    this.setState({
      exportConfirmation: true,
    });
  }

  fetchExcelData() {
    const { org2OrgHistoryList } = this.props;
    const newArray = org2OrgHistoryList.map((item) => {
      this.setState({
        exportConfirmation: false,
      });
      return {
        'Source Org': item.srcorgname,
        'Source Location': item.srclocname,
        'Target Org': item.trgtorgname,
        'Target Location': item.trgtlocname,
        Status: item.status,
        'Start Date': item.startdate,
        'Complete Date': item.completedate,
        Agent: item.agent,
      };
    });
    const type = 'application/vnd.openxmlformats-officedocument.spredsheetml.sheet;charset=UTF-8';
    const ws = XLSX.utils.json_to_sheet(newArray);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelBlob = new Blob([buffer], { type });
    FileSaver.saveAs(excelBlob, 'data.xlsx');
  }

  revertCopy() {
    Api.getRevertCopy(this.state.rowId)
      .then((data) => {
        let result = data.result || '';
        if (result != 'success') {
          this.setState({
            showErrorModal: true,
            errorMsg: result,
            showdetail: false,
          });
        } else {
          this.setState({
            showdetail: false,
          });
        }
      })
      .catch(() => {
        console.log('Error: unable to fetch product cont');
      });
  }

  handleUndoClick(index, data) {
    let row = data[index];
    Api.getProductCount(row.trgtLoc, row.trgtOrg)
      .then((data) => {
        let cnt = data.count || 0;
        if (cnt != '0' && row.isdone != 'N' && row.result) {
          this.setState({
            showdetail: true,
            srcorgname: row.srcorgname,
            srclocname: row.srclocname,
            trgtorgname: row.trgtorgname,
            trgtlocname: row.trgtlocname,
            productCount: cnt,
            rowId: row.id,
            isDisabledUndo: false,
          });
        }
      })
      .catch((e) => {
        console.log('Error: unable to fetch product cont');
        this.setState({
          showErrorModal: true,
          errorMsg: e.message,
          isDisabledUndo: true,
        });
      });
  }

  backToTable() {
    this.setState({
      showdetail: false,
      showErrorModal: false,
      exportConfirmation: false,
    });
  }

  handleSortChange(columnKey, sortDir) {
    let value = { [columnKey]: sortDir };
    this.setState({ columnSortDirs: value }, () => {
      Storage.setSessionItem(getColSortKey(this.props.tableTitle), value);
    });
  }

  handleFilter(e) {
    if (!e.target.value) {
      this.setState({ filterText: '' }, () => {
        Storage.setSessionItem(getFilterKey(this.props.tableTitle), '');
      });
      return;
    }

    const filterBy = this.refs.filterInput.value.toLowerCase();
    this.setState({ filterText: filterBy }, () => {
      Storage.setSessionItem(getFilterKey(this.props.tableTitle), filterBy);
    });
  }

  parseResult(result) {
    if (!result) return '';
    console.log('***********', JSON.parse(result));
    return JSON.parse(result);
  }

  renderError() {
    return (
      <ModalDialog>
        <h2 style={{ textAlign: 'left' }}>
          <i className='fa fa-exclamation-circle danger'></i> Error(s) Found
        </h2>
        <h3 style={{ textAlign: 'left' }}>Product Copy Cannot Be Undone</h3>
        <div style={{ textAlign: 'left' }}>{this.state.errorMsg}</div>
        <br />
        <br />
        <button
          className='pure-button pure-u-1-2'
          style={{ width: '100px', borderRadius: '10px', float: 'right' }}
          onClick={this.backToTable.bind(this)}
        >
          Close
        </button>
      </ModalDialog>
    );
  }

  renderDetail() {
    let detail = this.state.detail;
    let tableWidth = this.props.tableWidth || DEFAULT_TABLE_WIDTH;

    return (
      <div style={{ display: 'block', margin: '20px auto', width: tableWidth }}>
        <ModalContainer>
          <ModalDialog>
            <h1 style={{ textAlign: 'left' }}>Review the product copy details</h1>
            <h2 style={{ textAlign: 'left', fontWeight: 'normal' }}>Summary</h2>
            <ol style={{ listStyleType: 'none' }}>
              <li>
                <h3 style={{ textAlign: 'left', fontWeight: 'normal' }}>
                  Source Org: <span>{this.state.srcorgname}</span>
                </h3></li>
              <li>
                <h3 style={{ textAlign: 'left', fontWeight: 'normal' }}>
                  Source Location: <span>{this.state.srclocname}</span>
                </h3></li>
              <li>
                <h3 style={{ textAlign: 'left', fontWeight: 'normal' }}>
                  Target Org: <span>{this.state.trgtorgname}</span>
                </h3></li>
              <li>
                <h3 style={{ textAlign: 'left', fontWeight: 'normal' }}>
                  Target Location: <span>{this.state.trgtlocname}</span>
                </h3></li>
              <br />

              <li>
                <h3 style={{ textAlign: 'left', fontWeight: 'normal' }}>
                  Total Products to Copy: <span>{this.state.productCount}</span>
                </h3></li>
            </ol>
            <br />
            <br />
            <h2 style={{ textAlign: 'left', fontWeight: 'normal' }}>Do you want to continue?</h2>
            <button
              className='pure-button pure-u-1-2'
              style={{ width: '100px', borderRadius: '10px' }}
              onClick={this.backToTable.bind(this)}>
              Cancel
            </button>
            &nbsp;&nbsp;&nbsp;
            <button
              className='pure-button pure-button-primary pure-u-1-2'
              style={{ width: '100px', borderRadius: '10px' }}
              onClick={this.revertCopy.bind(this)}
            >
              Yes
            </button>
          </ModalDialog>
        </ModalContainer>
      </div>
    );
  }

  render() {
    const { filterText, columnSortDirs } = this.state;
    const { org2OrgHistoryList } = this.props;
    const dataList = DataTableUtil.filterList(
      org2OrgHistoryList,
      filterText,
      FILTER_COLUMNS,
      columnSortDirs
    );
    const size = org2OrgHistoryList.length;

    let tableWidth = this.props.tableWidth || DEFAULT_TABLE_WIDTH;
    let tableHeight = BaseLayout.calcTableHeight(org2OrgHistoryList) || DEFAULT_TABLE_HEIGHT;

    return (
      <div>
        {this.state.showdetail && !this.state.showErrorModal ? (
          this.renderDetail()
        ) : !this.state.showdetail && this.state.showErrorModal ? (
          this.renderError()
        ) : (
          <div style={{ display: 'block', margin: '20px auto', width: tableWidth }}>
            <div className='pure-g pure-u-1 card-label button-secondary'>
              <span onClick={this.handelexportConfirmation.bind(this)}>
                <i className='fa fa-fw fa-files-o' />{' '}
              </span>
              {this.props.tableTitle}
              <input
                className='table-search'
                type='search'
                placeholder='Search'
                ref='filterInput'
                value={filterText}
                onChange={this.handleFilter}
              />
            </div>
            <Table
              rowsCount={dataList.length}
              rowHeight={50}
              headerHeight={50}
              width={tableWidth}
              height={tableHeight}
              {...this.props}
            >
              <Column
                header={
                  <Cell>
                    <i className='fa fa-fw fa-undo' />
                  </Cell>
                }
                cell={(props) => (
                  <Cell {...props}>
                    <span
                      style={{ fontSize: 10 }}
                      onClick={(event, index) => {
                        this.handleUndoClick(props.rowIndex, dataList);
                      }}
                    >
                      {dataList[props.rowIndex].isdone != 'N' &&
                      dataList[props.rowIndex].result &&
                      !this.state.isDisabledUndo ? (
                        <i className='fa fa-fw fa-undo' />
                      ) : (
                        <i className='fa fa-fw fa-undo' style={{ color: 'grey' }} />
                      )}
                    </span>
                  </Cell>
                )}
                fixed={true}
                width={30}
                align='right'
              />
              <Column
                columnKey='srcorgname'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.srcorgname}>
                    Source Org
                  </SortHeaderCell>
                }
                cell={(props) => (
                  <Cell {...props} className='main-cell' style={{ color: 'black' }}>
                    {dataList[props.rowIndex].srcorgname}
                  </Cell>)}
                fixed={true}
                width={150}
              />
              <Column
                columnKey='srclocname'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.srclocname}>
                    Source Location
                  </SortHeaderCell>
                }
                cell={(props) => <Cell {...props}>{dataList[props.rowIndex].srclocname}</Cell>}
                fixed={true}
                width={150}
              />
              <Column
                columnKey='trgtorgname'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.trgtorgname}>
                    Target Org
                  </SortHeaderCell>
                }
                cell={(props) => <Cell {...props}>{dataList[props.rowIndex].trgtorgname}</Cell>}
                fixed={true}
                width={150}
              />
              <Column
                columnKey='trgtlocname'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.trgtlocname}>
                    Target Location
                  </SortHeaderCell>
                }
                cell={(props) => <Cell {...props}>{dataList[props.rowIndex].trgtlocname}</Cell>}
                fixed={true}
                width={150}
              />
              <Column
                columnKey='status'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.status}>
                    Status
                  </SortHeaderCell>
                }
                cell={<TextCell dataList={dataList} field='status' />}
                fixed={true}
                width={70}
              />
              <Column
                columnKey='startdate'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.startdate}>
                    Start date
                  </SortHeaderCell>
                }
                cell={<TextCell dataList={dataList} field='startdate' />}
                fixed={true}
                width={170}
              />
              <Column
                columnKey='completedate'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.completedate}>
                    Complete date
                  </SortHeaderCell>
                }
                cell={<TextCell dataList={dataList} field='completedate' />}
                fixed={true}
                width={170}
              />
              <Column
                columnKey='agent'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.agent}>
                    Agent
                  </SortHeaderCell>
                }
                cell={<TextCell dataList={dataList} field='agent' />}
                fixed={true}
                width={180}
              />
            </Table>
            <div className='pure-g' style={{ padding: '5px 0' }}>
              <div className='pure-u-1-3'>
                {dataList.length < size ? (
                  <span>
                    Showing {dataList.length} entries (filtered from {size} total entries)
                  </span>
                ) : (
                  <span>
                    Showing {dataList.length} of {size}
                  </span>
                )}
              </div>
              <div className='pure-u-1-3'></div>
              <div className='pure-u-1-3' style={{ textAlign: 'right' }}></div>
            </div>
          </div>
        )}
        {this.state.exportConfirmation && (
          <ModalContainer>
            <ModalDialog>
              <h2 style={{ textAlign: 'left' }}>Export Copy history to Excel?</h2>
              <button
                className='pure-button pure-u-1-2'
                style={{ width: '100px', borderRadius: '10px' }}
                onClick={this.backToTable.bind(this)}>
                Cancel
              </button>
              &nbsp;&nbsp;&nbsp;
              <button
                className='pure-button pure-button-primary pure-u-1-2'
                style={{ width: '100px', borderRadius: '10px' }}
                onClick={this.fetchExcelData.bind(this)}>
                Yes
              </button>
            </ModalDialog>
          </ModalContainer>
        )}
      </div>
    );
  }
}

export default Org2OrgCopyPageHistory;



// WEBPACK FOOTER //
// ./src/components/pages/Org2OrgCopyPageHistory.js